import { useData } from "data/data-provider";
import MyRouter from "routers/index";

function App() {
  const { loadingCompanyDetails } = useData();

  return (
    <>
      {loadingCompanyDetails ? (
        <div className="flex justify-center items-center col-span-full min-h-[100vh]">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
        </div>
      ) : (
        <div className="text-base text-text-color bg-bg-color">
          <MyRouter />
        </div>
      )}
    </>
  );
}

export default App;
